export const ImageReport = {
  camerasAreNotConfigured:
    "Las cámaras seleccionadas no están configuradas para detectar entradas y/o salidas.",
  eventType: "Tipo de evento",
  eventState: "Estado del evento",
  pdfDisclaimer:
    "Nota: Algunas imágenes han sido omitidas de este informe para mejorar el rendimiento. Para ver todas las imágenes, acceda a la aplicación.",
  filterType: "Tipo de filtro",
  filterTypeSubject: "Tipo",
  filterTypeState: "Estado",
};
